<script setup lang="ts">
import { computed, type Component } from "vue";
import { useRoute } from "vue-router";

const props = withDefaults(
  defineProps<{
    label: string;
    to?: string;
    action?: () => void;
    /** Optional: a row inside a group can be plain text. Every row in this menu carries one today. */
    iconComponent?: Component;
    activeNames?: string[];
    active?: boolean;
    dataCy?: string;
  }>(),
  { activeNames: () => [], active: undefined }
);

defineEmits<{ navigate: [] }>();

const route = useRoute();
const isActive = computed(() => props.active ?? props.activeNames.includes(route.name as string));

const baseClass = computed(() => [
  "focus-ring interactive-active gap-px-12 text-type-default duration-fast hover:bg-app-blue-200/30 ease-standard rounded-8 t-small-bold flex w-full items-center px-px-12 py-px-12 text-left transition-colors",
  isActive.value ? "ring-app-blue-500 bg-app-blue-200/20 ring-1" : "",
]);
</script>

<template>
  <RouterLink
    v-if="to"
    :to="to"
    :class="baseClass"
    :data-cy="dataCy"
    :aria-current="isActive ? 'page' : undefined"
    @click="$emit('navigate')">
    <component
      :is="iconComponent"
      v-if="iconComponent"
      :stroke-width="1.5"
      fill="var(--color-app-blue-100)"
      color="var(--color-app-blue-800)"
      class="icon-md shrink-0" />
    <span>{{ label }}</span>
  </RouterLink>

  <button
    v-else
    type="button"
    :class="baseClass"
    :data-cy="dataCy"
    @click="
      action?.();
      $emit('navigate');
    ">
    <component
      :is="iconComponent"
      v-if="iconComponent"
      :stroke-width="1.5"
      fill="var(--color-app-blue-100)"
      color="var(--color-app-blue-800)"
      class="icon-md shrink-0" />
    <span>{{ label }}</span>
  </button>
</template>
